import { ContextProvider, Context } from '@front10/helpers/dist/Context';
import { LazyLoadingContextProvider } from '../lazyLoadImage';
import { IconProvider } from '@front10/utils';
import React, { useContext } from 'react';
import { mergeDeep } from '../../../../helpers/utils';
import {
  TrackingProvider,
  useContainerProps
} from '../../../../_integrations/everymundo/tracking/airlines';
import ErrorBoundary from '../../../utils/ErrorBoundary';

const defaultTranslate = (key: string, defaultValue?: string) => defaultValue || key;

function withCommonEMContainer<T extends WithEMContainerProps = WithEMContainerProps>(
  WrappedComponent: React.ComponentType<T>
) {
  function CommonEMContainer(props: WithEMContainerProps) {
    const context = useContext(Context);
    const {
      enableErrorBoundary = true,
      translate = context.translate || defaultTranslate,
      direction = context.direction || 'ltr',
      localizationData = context.localizationData || null,
      theme = context.theme || null,
      moment = null,
      integrationSettings = {},
      iconProvider = {
        config: {},
        icons: []
      }
    } = props;

    // Weird hack to guarantying having access to the default props
    // of the wrappedComponent
    const wrappedDefaults = mergeDeep({}, WrappedComponent.defaultProps);
    const propsCopy = Object.assign(wrappedDefaults, props, {
      enableErrorBoundary,
      translate,
      direction,
      localizationData,
      theme,
      integrationSettings,
      iconProvider
    });
    const { prePopulation } = propsCopy;

    // patch to solve EM issue with the evaluation of endpoints
    if (prePopulation.airlineIataCode) {
      prePopulation.airlineCode = prePopulation.airlineIataCode;
    }

    // here any transformation... evaluation, all common stuff to all class containers

    const trackingProps = useContainerProps(propsCopy);
    return (
      <ContextProvider
        translate={translate}
        direction={direction}
        localizationData={localizationData}
        theme={theme}
        moment={moment}
      >
        <IconProvider iconProvider={iconProvider}>
          <LazyLoadingContextProvider>
            <TrackingProvider value={trackingProps}>
              {enableErrorBoundary ? (
                <ErrorBoundary>
                  <WrappedComponent {...propsCopy} />
                </ErrorBoundary>
              ) : (
                <WrappedComponent {...propsCopy} />
              )}
            </TrackingProvider>
          </LazyLoadingContextProvider>
        </IconProvider>
      </ContextProvider>
    );
  }

  CommonEMContainer.defaultProps = {
    meta: {
      moduleId: 'em-cmp-lib-airmodules',
      name: 'TO_BE_OVERWRITE_BY_THE_SPECIFIC_CONTAINER',
      version: 'NO_NEEDED'
    },
    pageContext: {
      deviceCategory: 'DESKTOP',
      siteEdition: 'en_HK'
    }
  };

  return CommonEMContainer;
}

export default withCommonEMContainer;
